import { render, staticRenderFns } from "./VSubscriptionForm.vue?vue&type=template&id=70fc1e9f&"
import script from "./VSubscriptionForm.vue?vue&type=script&lang=js&"
export * from "./VSubscriptionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports